import { Alert, AlertIcon, AlertTitle, Flex, Heading } from "@chakra-ui/react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";
import { useAuthentication } from "./AuthenticationContext";

function FullPageCenteredContainer({ children }: { children: ReactNode }) {
  return (
    <Flex
      height="100vh"
      width="100vw"
      overflow="hidden"
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      {children}
    </Flex>
  );
}

export default function OAuth2AuthCodeCallback() {
  const { isPendingAuthentication, error } = useAuthentication();
  const { t } = useTranslation();
  const [state] = useQueryParam("state", StringParam);

  // Wait for both authentication to finish and user to be present
  if (isPendingAuthentication) {
    return (
      <FullPageCenteredContainer>
        <Alert status="loading" maxW={"container.sm"}>
          <AlertIcon />
          <AlertTitle>{t("authorization_in_progress")}</AlertTitle>
        </Alert>
      </FullPageCenteredContainer>
    );
  }

  if (error) {
    return (
      <FullPageCenteredContainer>
        <Alert status="error" maxW={"container.sm"}>
          <AlertIcon />
          {error}
        </Alert>
      </FullPageCenteredContainer>
    );
  }

  const [pathname, search] = (state ?? "/").split("?");

  return (
    <>
      <FullPageCenteredContainer>
        <Heading>
          <Alert status="info" maxW={"container.sm"}>
            <AlertIcon />
            {t("will_redirect_to")} {state} ...
          </Alert>
        </Heading>
      </FullPageCenteredContainer>
      <Navigate to={{ pathname, search }} />
    </>
  );
}
